<div class="d-flex justify-content-center align-items-center gap-2">
    <button class="btn eod-btn-primary btn-sm" (click)="onUserAction('subscribe')">
        Subscribe 
    </button>

    <button class="btn eod-btn-danger btn-sm" (click)="onUserAction('endTrial')">
       End Trial
    </button>
</div>